import {UploadIconStart} from "../../../assets/svg/uploadIconStart";
import {useState} from "react";
import {UploadIconEnd} from "../../../assets/svg/uploadIconEnd";
import {StyledAddButton} from "./AddButton.styled";

interface AddButtonProps {
  aboutFunction: () => void
}

export function UiAddButton({aboutFunction}: AddButtonProps) {
  const [hovered, setHovered] = useState<boolean>(false)

  return (
    <StyledAddButton
      onClick={aboutFunction}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {hovered ? <UploadIconStart /> : <UploadIconEnd />}
    </StyledAddButton>
  )
}